import type { User } from '@supabase/supabase-js'
import { supabase } from '@/lib/supabase'

/** Ensure public.profiles row exists (group_members.user_id FK). */
export async function ensureProfile(user: User): Promise<void> {
  const displayName =
    (typeof user.user_metadata?.full_name === 'string' && user.user_metadata.full_name.trim()) ||
    user.email?.split('@')[0] ||
    'User'

  const { error } = await supabase.rpc('ensure_my_profile', { p_display_name: displayName })
  if (error) throw error
}
